import SignedDocumentsElement from "components/elements/subscriptionSummaryElements/SignedDocumentsElement";
import I18n from "components/materials/I18n";
import useHead from "hooks/useHead";

export default function MOSignedDocuments() {
	useHead({
		title: `${I18n.asset.pages.mo_subscription_summary.page_title} - ${I18n.asset.pages.mo_subscription_summary.sub_pages.signed_documents.page_title}`,
	});

	return <SignedDocumentsElement />;
}
